import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getAuthProps } from '@topconagriculture/auth';
import { configureModalMap, useModal } from '@topconagriculture/modal';
import WidgetAddModal from './WidgetAddModal';
import { useDashboardAPI, useDashboardConfig, useWidgetsListQuery } from '../../hooks';
import { useTranslation } from 'react-i18next';
import WidgetsGrid from './WidgetsGrid';
import { makeStyles } from '@material-ui/styles';
import { Button, Loading, Placeholder, RoundButton, Tooltip } from '@topconagriculture/react-components';
export const widgetAddModalName = '@@widget/add';
configureModalMap({ [widgetAddModalName]: React.createElement(WidgetAddModal, null) });
const useStyles = makeStyles((theme) => ({
    dashboardPage: {
        position: 'relative',
        zIndex: 100,
        width: '100%',
        display: 'flex',
    },
    addUserBtn: {
        position: 'fixed',
        bottom: theme.space.margin.large,
        right: theme.space.margin.large,
        width: 85,
        height: 85,
        margin: '0 auto',
        zIndex: 109,
    },
    content: { flex: 1 },
}));
export const Dashboard = () => {
    const classes = useStyles();
    const { token, impersonationToken } = useSelector(getAuthProps);
    const api = useDashboardAPI();
    const config = useDashboardConfig();
    const [auth, setAuth] = useState(false);
    const { t } = useTranslation();
    const { dispatchOpenModal } = useModal();
    const { data, isLoading } = useWidgetsListQuery({ enabled: auth });
    useEffect(() => {
        if (token) {
            api.setAuthToken({ token, impersonationToken }, config.TENANT_ID);
            setAuth(true);
        }
    }, [token, impersonationToken]);
    const onAddWidget = useCallback(() => {
        dispatchOpenModal({
            modalName: widgetAddModalName,
            modalOptions: {
                modalDialogProps: {
                    maxWidth: 'xl',
                },
            },
        });
    }, [dispatchOpenModal]);
    return (React.createElement("div", { className: classes.dashboardPage },
        React.createElement(Loading, { isLoading: isLoading || !auth }),
        !(data === null || data === void 0 ? void 0 : data.length) ? (React.createElement(Placeholder, { title: t('widget:generic:empty_state_title'), description: t('widget:generic:empty_state_description'), iconName: "add-widget" },
            React.createElement(Button, { onClick: onAddWidget, label: t('widget:generic:add_widget'), iconName: 'add' }))) : (React.createElement(React.Fragment, null,
            React.createElement(WidgetsGrid, { widgets: data }),
            React.createElement(Tooltip, { title: t('widget:generic:add_widget') },
                React.createElement(RoundButton, { size: 'small', className: classes.addUserBtn, onClick: onAddWidget, iconName: "plus", iconSize: 30 }))))));
};
//# sourceMappingURL=Dashboard.js.map